<template>
  <div :class="`${$attrs.class} mt-auto common-progress-bar-wrapper`">
    <div class="text-base font-semibold" v-if="title">{{ title }}</div>
    <ap-progress
      class="m-0"
      :trail-color="trailColor"
      :stroke-color="strokeColor"
      stroke-linecap="square"
      :show-info="false"
      :percent="percent" />
    <div class="text-xs text-black/80" v-if="caption">{{ caption }}</div>
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  title: {
    type: String,
    default: () => ""
  },
  caption: {
    type: String,
    default: () => ""
  },
  valueMax: {
    type: Number,
    default: () => 0
  },
  valueNow: {
    type: Number,
    default: () => 0
  },
  trailColor: {
    type: String,
    default: "#12121214"
  },
  strokeColor: {
    type: String,
    default: "#4663C6B2"
  }
})
const percent = computed(() => (100 * props?.valueNow) / props?.valueMax)
</script>

<style lang="postcss">
.common-progress-bar-wrapper .ant-progress .ant-progress-outer .ant-progress-inner {
  @apply rounded-none;

  .ant-progress-bg {
    @apply !bg-primary/60;
  }
}
</style>
